import $ from 'jquery';
import BaseComponent from './baseComponent';

/**
 * Make Table responsive.
 */
export default class ResponsiveTable extends BaseComponent {
  /**
     * Public constructor
     *
     * @param options
     */
  constructor(options) {
    super(options);

    this.$tableWrappers = $('.table-wrapper');

    return this;
  }

  makeTableResponsive($tableWrapper) { // eslint-disable-line class-methods-use-this
    let $table = $tableWrapper.find('table');
    const firstColumns = $table.find('tr');
    let firstColumnWidth = 0;
    let newContent = '';

    $.each(firstColumns, (i, tr) => {
      const $tr = $(tr);
      let $tds = $tr.find('td');

      if ($tds.length < 1) {
        $tds = $tr.find('th');
      }

      if (firstColumnWidth === 0) {
        firstColumnWidth = $tds.first().outerWidth();
      }

      $.each($tds, (ii, td) => {
        const $td = $(td);

        $td.width(firstColumnWidth);
      });
    });

    $table = $tableWrapper.find('table');

    newContent += '<div class="responsive-wrapper">';
    newContent += `<div class="table-responsive-left" style="width: ${firstColumnWidth}px;">`;
    newContent += `<table>${$table.html()}</table>`;
    newContent += '</div><div class="table-responsive-right">';
    newContent += `<table style="margin-left: -${firstColumnWidth}px;">${$table.html()}</table>`;
    newContent += '</div>';
    newContent += '</div>';

    $table.before(newContent);

    const $responsiveWrapper = $tableWrapper.find('.responsive-wrapper');
    $responsiveWrapper.on('touchstart mousedown', () => {
      $responsiveWrapper.addClass('-hiddenoverlay');
    });
  }

  /**
     * Check if the table should be responsive.
     * Compares the wrapper-width (place we have for displaying)...
     * ...with the table-width (place we need to display)
     *
     * @param $tableWrapper
     * @returns {boolean}
     */
  shouldTableBeResponsive($tableWrapper) { // eslint-disable-line class-methods-use-this
    const wrapperWidth = $tableWrapper.outerWidth();
    const tableWidth = $tableWrapper.find('table').outerWidth();

    return wrapperWidth < tableWidth;
  }

  /**
     * Initialize function
     */
  init() {
    if (this.$tableWrappers.length < 1) {
      return;
    }

    $.each(this.$tableWrappers, (index, element) => {
      const $tableWrapper = $(element);
      if (this.shouldTableBeResponsive($tableWrapper)) {
        this.makeTableResponsive($tableWrapper);
      }
    });
  }

  updateOnResize() {
    if (this.$tableWrappers.length < 1) {
      return;
    }

    $.each(this.$tableWrappers, (index, element) => {
      const $tableWrapper = $(element);
      $tableWrapper.find('.responsive-wrapper').remove();

      if (this.shouldTableBeResponsive($tableWrapper)) {
        this.makeTableResponsive($tableWrapper);
      }
    });
  }
}
